export default class AccessTokenService {

  constructor($cookies) {
    'ngInject';
    this.cookies = $cookies;
  }

  getToken() {
    return this.cookies.get('token');
  }

  setToken(token){
    this.cookies.put('token', token);
  }

  removeToken() {
    this.cookies.remove('token');
  }
}



// WEBPACK FOOTER //
// ./client/app/common/interceptors/accessToken/accessToken.service.js